import React from 'react';
import { Navigate } from 'react-router-dom';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import PayrollPortal from '../components/PayrollPortal';

const PayrollPortalPage = ({ user, setUser }) => {
  // Restrict access to Admin and SuperAdmin only
  if (!user || (user.role !== 'admin' && user.role !== 'superadmin')) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50" data-testid="payroll-portal-page">
      <Header user={user} setUser={setUser} />
      <Navigation user={user} />
      
      <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-screen-2xl mx-auto w-full">
        <PayrollPortal user={user} />
      </div>
    </div>
  );
};

export default PayrollPortalPage;
